import TemplateSuccess from "Components/Templates/Success";

export default function PageSuccess() {
   console.log("step success");

   return (
      <>
         <TemplateSuccess></TemplateSuccess>
      </>
   );
}
